module.exports = __webpack_public_path__ + "static/media/chart-pie.a225c304.svg";